module.exports = __webpack_public_path__ + "img/visa-autre.0268519b.png";